import { scrollTo } from "@/scripts/common/scroll-to";

document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.addEventListener("tab:change", (e) => {
    if (!e.detail.url) {
      return;
    }

    const startTime = performance.now();

    requestAnimationFrame(() => {
      const elapsedTime = performance.now() - startTime;
      const remainingTime = Math.max(0, 100 - elapsedTime);

      setTimeout(() => {
        window.location.href = e.detail.url;
      }, remainingTime);
    });
  });

  window.addEventListener("beforeunload", () => {
    sessionStorage.setItem("scrollPosition", window.scrollY);
  });

  window.addEventListener("load", () => {
    const scrollPosition = sessionStorage.getItem("scrollPosition");
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition));
      sessionStorage.removeItem("scrollPosition");
    }
  });
});
